import React, { useState, useEffect } from "react";
import Editor from "../TET/Editor";
import "./style.css";
const WidgetModel4 = ({ initialData = {}, onChange }) => {
  const [htmlContent, setHtmlContent] = useState(initialData.htmlContent || "");
  useEffect(() => {
    onChange && onChange({ htmlContent });
    // eslint-disable-next-line
  }, [htmlContent]);

  return (
    <div>
      <h3>HTML Content</h3>
      <Editor textState={htmlContent} onTextChange={setHtmlContent} />
    </div>
  );
};
export default WidgetModel4;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Content Management/WidgetModel4.js